const css = `.dboZvW__listItem,.dboZvW__expandedEventInfoListItem{width:100%;transition:height .1s;position:absolute}.dboZvW__expandedEventInfoListItem{z-index:1;flex-direction:column;gap:8px;display:flex}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"listItem":"dboZvW__listItem","expandedEventInfoListItem":"dboZvW__expandedEventInfoListItem"};
